if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      show(opener) {
        super.show(opener);

        // Re-query because cart DOM content may be replaced after updates
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      hide() {
        super.hide();

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }
    },
  );
}
